// extracted by mini-css-extract-plugin
export default {"welcomeMessage":"WelcomeNewUserScreen_welcomeMessage__tpDxy"};